export class Labels {


  public userIdle = {
    modal: {
      title: 'Sua sessão irá expirar em breve.',
      text1: 'Para sua segurança, sua sessão irá expirar em ',
      text2: 'por inatividade. Você ainda está aqui?',
      button: {
        exit: 'Sair',
        label: 'Ainda estou aqui!',
      },
      expired: {
        title: 'Sua sessão expirou!',
        body: 'Por favor, entre novamente para continuar usando o <strong>Portal de Logons</strong>.',
        button: {
          label: 'Ir para página de login',
        },
      },
    },
  };

}
